module.exports = __webpack_public_path__ + "img/稿定设计-3.14654e52.jpg";